import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCalls } from '@/api/api';
import { Briefcase, Calendar, User } from 'lucide-react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { toast } from 'sonner';

const PortfolioSearches = () => {
  const navigate = useNavigate();
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCalls();
  }, []);

  const loadCalls = async () => {
    try {
      const data = await getCalls();
      // Sadece Portföy aramalarını filtrele
      const portfolioCalls = data.filter(call => call.call_type === 'Portföy');
      setCalls(portfolioCalls);
    } catch (error) {
      toast.error('Aramalar yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-12">Yükleniyor...</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-4xl font-bold progo-text mb-2">Portföy Aramaları</h1>
        <p className="text-gray-600">Toplam {calls.length} arama kaydı</p>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6">
        {calls.length === 0 ? (
          <div className="text-center py-12">
            <Briefcase className="w-16 h-16 mx-auto text-purple-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Henüz Arama Kaydı Yok</h3>
            <p className="text-gray-600">
              Müşteri detay sayfalarından "Arama Yap" ile portföy araması yapabilirsiniz.
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {calls.map((call, index) => (
              <div 
                key={call.id} 
                className="border rounded-lg p-4 hover:bg-gray-50 transition-colors cursor-pointer" 
                onClick={() => navigate(`/customers/${call.customer_id}`)}
                data-testid={`call-${index}`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <span className="text-lg font-semibold text-gray-900 mb-2 block">
                      {call.customer_name}
                    </span>
                    <div className="space-y-1 text-sm text-gray-600">
                      <div className="flex items-center space-x-2">
                        <Calendar className="w-4 h-4" />
                        <span>{format(new Date(call.call_date), 'dd MMMM yyyy HH:mm', { locale: tr })}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <User className="w-4 h-4" />
                        <span>Temsilci: {call.representative}</span>
                      </div>
                      {call.notes && (
                        <p className="text-gray-700 mt-2">
                          <strong>Notlar:</strong> {call.notes}
                        </p>
                      )}
                    </div>
                  </div>
                  <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">
                    Portföy
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PortfolioSearches;
